import { Component, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { filter, Observable } from 'rxjs';
import { BreadcrumbService } from 'xng-breadcrumb';
import { View } from '../../../../shared/store/view/types';
import { ViewService } from '../../../../shared/store/view/views.service';

@UntilDestroy()
@Component({
  selector: 'app-sales-dashboard',
  templateUrl: './sales-dashboard.component.html',
  styleUrls: ['./sales-dashboard.component.scss'],
  standalone: false,
})
export class SalesDashboardComponent implements OnInit {
  startDate: Date;
  endDate: Date;
  campaignId: number;
  insuranceType: number;
  salesTeamId: number;
  salesTeamMemberId: number;
  userId: number;
  view$: Observable<View>;

  productCategoryIds: number[] = [-1];
  salesTeamIds: number[] = [-1];
  salesTeamMemberUserIds: number[] = [-1];
  campaignIds: number[] = [-1];
  sourceIds: number[] = [-1];
  mediumIds: number[] = [-1];

  //"All" Value
  productCategoryIdAllValue: number = -1; //id
  salesTeamIdAllValue: number = -1; //id
  salesTeamMemberUserIdAllValue: number = -1; //userId
  campaignIdAllValue: number = -1; //id
  sourceIdAllValue: number = -1; //id
  mediumIdAllValue: number = -1; //id

  constructor(
    private readonly breadcrumbService: BreadcrumbService,
    private readonly viewService: ViewService,
  ) {
    this.view$ = this.viewService.getViews.value$;
  }

  ngOnInit(): void {
    //TODO : Initialize with period
    this.startDate = new Date();
    this.startDate.setDate(this.startDate.getDate() - 29);
    this.endDate = new Date();
    this.endDate.setDate(this.endDate.getDate());

    this.view$
      .pipe(
        untilDestroyed(this),
        filter((x) => !!x),
      )
      .subscribe((x) => {
        this.breadcrumbService.set('@salesDashboard', x.title);
      });
  }
}
